module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-note-list row column"
  }, _vm._l((_vm.reservation_rates), function(rate) {
    return _c('reservation-rate', {
      attrs: {
        "item": rate,
        "type": "listing"
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a35778d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReservationRateList.vue
// module id = 2275
// module chunks = 1